import { Component, OnInit, ViewChild, TemplateRef, Output, EventEmitter, OnDestroy } from '@angular/core';
import { PerfectScrollbarConfigInterface, PerfectScrollbarComponent, PerfectScrollbarDirective } from 'ngx-perfect-scrollbar';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { Dateconfig } from 'src/app/configuration/dateconfig/dateconfig';
import { ToastrService } from 'ngx-toastr';
import { SimpleModalService } from 'ngx-simple-modal';
import { ConfirmComponent } from '../../confirm/confirm';
import { CustomLoaderCComponent } from 'src/app/CustomLoader/custom-loader/custom-loader-c/custom-loader-c.component';
import { Router, ActivatedRoute } from '@angular/router';
import { ChallanService } from 'src/app/_services/Challan/challan.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LocalStorageConstants } from 'src/app/common/LocalStorageConstants';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-allchallan',
  templateUrl: './allchallan.component.html',
  styleUrls: ['./allchallan.component.css'],
  providers: [Dateconfig, CustomLoaderCComponent, ToastrService]

})
export class AllchallanComponent implements OnInit, OnDestroy {

  columns: any = [];
  rows: any;
  temp = [];
  temp2 = [];
  confirmResult = null;
  @ViewChild('modalContent') modalContent: TemplateRef<any>;
  public config: PerfectScrollbarConfigInterface = {};
  @ViewChild(PerfectScrollbarComponent) componentRef?: PerfectScrollbarComponent;
  @ViewChild(PerfectScrollbarDirective) directiveRef?: PerfectScrollbarDirective;
  @Output() closeModalEvent = new EventEmitter<boolean>();
  @ViewChild(DatatableComponent) table: DatatableComponent;

  allchallansSubscription?: Subscription;
  deleteChallansSubscription?: Subscription;

  public breadcrumb: any;
  constructor(
    private spinner: CustomLoaderCComponent,
    private dateconfig: Dateconfig,
    private modalpop: NgbModal,
    private toastrService: ToastrService,
    private router: ActivatedRoute,
    private routernav: Router,
    private challanService: ChallanService,
    private SimpleModalService: SimpleModalService

  ) { }

  UserTypeDescription
  ngOnInit() {
    this.UserTypeDescription = localStorage.getItem(LocalStorageConstants.USER_TYPE_DESCRIPTION);
    this.breadcrumb = {
      'mainlabel': 'All Challan',

    };
    this.spinner.showSpinner();


    this.allchallansSubscription = this.challanService.getall().subscribe(Response => {
      this.rows = Response;
      this.temp2 = Response;
      this.temp = Response;
      this.spinner.hideSpinner();
    });
  }

  ngOnDestroy(): void {
    this.allchallansSubscription?.unsubscribe();
    this.deleteChallansSubscription?.unsubscribe();
  }

  updateFilter(event: any) {
  const val = (event.target.value || '').toLowerCase();
  this.rows = this.temp2;
  this.temp = this.rows;

  this.rows = this.rows.filter((d: any) =>
    (d.customerFullName?.toLowerCase().includes(val)) ||
    (d.challanItemBarcodeDescription?.toLowerCase().includes(val)) ||
    (d.challanDate?.toString('dd-MMM-yyyy').toLowerCase().includes(val)) ||
    (d.challanContactNo?.toLowerCase().includes(val)) ||
    !val
  );
}

  convertdate(date) {
    return this.dateconfig.shortyydd(date);
  }

  showConfirm(id: any) {
    this.SimpleModalService.addModal(ConfirmComponent, {
      title: 'Confirmation',
      message: 'Are you sure to delete this record ?'
    }).subscribe((isConfirmed: boolean) => {
      this.confirmResult = isConfirmed;
      if (!isConfirmed) return;

      this.spinner.showSpinner();
      this.deleteChallansSubscription = this.challanService.delete(id).subscribe({
        next: (res: any) => {
          this.spinner.hideSpinner();
          if (res.result === 1) {
            this.ngOnInit();
            this.toastrService.success(res.userMessage, '', { timeOut: 1000, closeButton: true });
          } else {
            this.toastrService.error(res.userMessage, '', { timeOut: 3000, closeButton: true });
          }
        },
        error: () => {
          this.spinner.hideSpinner();
          this.toastrService.error('Server is down', '', { timeOut: 3000, closeButton: true });
        }
      });
    });
  }

  encrypt(id) {
    return btoa(id);
  }

}
